module.exports = {
	"id": "CN",
	"name": "China",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.108912,
			"12": 0.009076,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": 0.027228,
			"18": 0.004538,
			"19": null,
			"20": 0.040842,
			"21": 0.06807,
			"22": 0.013614,
			"23": 0.004538,
			"24": 0.009076,
			"25": 0.02269,
			"26": 0.027228,
			"27": 0.013614,
			"28": 0.013614,
			"29": 0.06807,
			"30": 0.04538,
			"31": 0.344888,
			"32": 0.02269,
			"33": 0.054456,
			"34": 0.031766,
			"35": 0.02269,
			"36": 0.049918,
			"37": 0.018152,
			"38": 0.06807,
			"39": 0.140678,
			"40": 0.018152,
			"41": 0.040842,
			"42": 1.393166,
			"43": 0.09076,
			"44": 0.09076,
			"45": 11.36769,
			"46": 0.122526,
			"47": 1.756206,
			"48": 0.299508,
			"49": 0.585402,
			"50": 2.350684,
			"51": 0.585402,
			"52": 0.444724,
			"53": 1.506616,
			"54": 0.367578,
			"55": 0.054456,
			"56": 0.004538,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.018152,
			"4": 0.013614,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.535484,
			"9": null,
			"10": null,
			"11": 0.004538,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.009076,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.004538,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.004538,
			"36": null,
			"37": 0.004538,
			"38": 0.013614,
			"39": 0.009076,
			"40": 0.018152,
			"41": 0.009076,
			"42": 0.009076,
			"43": 0.054456,
			"44": 0.018152,
			"45": 0.036304,
			"46": 0.031766,
			"47": 0.176982,
			"48": 0.086222,
			"49": 1.093658,
			"50": 0.009076,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.009076
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.004538,
			"37": null,
			"38": 0.027228,
			"39": null,
			"40": 0.063532,
			"41": 0.009076,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.009076
		},
		"safari": {
			"0": null,
			"4": 0.013614,
			"5": 0.009076,
			"6": 0.004538,
			"7": 0.009076,
			"8": 0.031766,
			"9": 0.036304,
			"10": 0.263204,
			"3.1": null,
			"3.2": null,
			"5.1": 0.009076,
			"6.1": 0.004538,
			"7.1": null,
			"9.1": 0.149754
		},
		"ios_saf": {
			"8": 0,
			"10": 5.68015993589,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.153073737614,
			"8.1-8.4": 0.282797244067,
			"9.0-9.2": 0.134912446711,
			"9.3": 2.05827963572
		},
		"android": {
			"3": 0,
			"4": 0.0884384883721,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0110548110465,
			"4.1": 0.319010261628,
			"4.2-4.3": 0.79752565407,
			"4.4": 1.82878159884,
			"4.4.3-4.4.4": 1.84457418605
		},
		"ie": {
			"6": 0.764393654711,
			"7": 0.225558783357,
			"8": 5.55751780105,
			"9": 1.8608599627,
			"10": 0.739331567671,
			"11": 3.76557857771,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00263720051639,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0000732555698996
		},
		"edge": {
			"12": 0.040842,
			"13": 0.258666,
			"14": 0.440186
		},
		"ie_mob": {
			"10": 0.0161581690141,
			"11": 0.0657868309859
		},
		"bb": {
			"7": 0.005463,
			"10": null
		},
		"samsung": {
			"0": 0.737505
		},
		"and_uc": {
			"0": 17.142894
		},
		"op_mini": {
			"0": 0.0355305439137
		},
		"and_chr": {
			"0": 24.665647
		},
		"and_ff": {
			"0": 0.010926
		}
	},
	"total": 94.6565313472
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CN.json
 ** module id = 498
 ** module chunks = 0
 **/